import React from 'react';
import styled from 'styled-components';

const PaddedProp = styled.div`
  padding-right: 24px;
`;

export default PaddedProp;
